const isOnBlockedWindow = (
  subscriptionStartedAt: string,
  blockUpgradeWindowThreshold: number
) => {
  if (subscriptionStartedAt) {
    const windowStart = new Date(subscriptionStartedAt);
    const windowEnd = new Date(subscriptionStartedAt);
    const currentDate = new Date();

    windowEnd.setHours(
      windowEnd.getHours() + (blockUpgradeWindowThreshold ?? 0)
    );

    return currentDate > windowStart && currentDate < windowEnd;
  }
};

export const shouldAllowUpgrade = (
  isOnSignUpPlan: boolean,
  hasPlansWithout5ReportBlocker: boolean,
  subscriptionStartedAt: string,
  blockUpgradeWindowThreshold: number,
  reportsRun: number,
  validReportCountThreshold: number
) => {
  // The upgrades should be hidden if:
  // 1. Less than 24 hours have passed since the last upgrade or signup.
  // 2. The user is on the signup plan and has not completed 5 reports.
  if (isOnBlockedWindow(subscriptionStartedAt, blockUpgradeWindowThreshold)) {
    return false;
  }
  if (isOnSignUpPlan && !hasPlansWithout5ReportBlocker) {
    return reportsRun >= (validReportCountThreshold ?? 0);
  }
  return true;
};
